module.exports = __webpack_public_path__ + "static/media/twitter-original.fb2c456d.svg";